import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Fields from 'ui/form/FieldsForm';

const useStyles = makeStyles(theme => ({
    boldText: {
        fontWeight: 500,
    },
    fakeField: {
        border: `solid 1px ${theme.palette.text.secondary}`,
        borderRadius: theme.spacing() / 2,
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        marginTop: theme.spacing(),
        fontWeight: 500,
        fontSize: '1rem',
        display: 'inline-block',
        marginBottom: theme.spacing(2),
    },
    imageContainer: {
        width: '100%',
        textAlign: 'center',
    },
    text: {
        width: '50%',
    },
}));

export const TOTPForm = ({ onChange, values, error }) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="body1" className={classes.boldText}>
                Scan the image with the two-factor authentication app on your
                phone.
            </Typography>
            <div className={classes.imageContainer}>
                <img src={values.qr} alt="qr" style={{ width: 200 }} />
            </div>
            <Typography
                variant="body1"
                className={classes.boldText}
                color="secondary"
            >
                If you cannot use a barcode, enter the code below instead.
            </Typography>
            <FakeField>{values.mfa_code}</FakeField>
            <Typography variant="body1" className={classes.boldText}>
                Enter the six-digit code from the application
            </Typography>
            <Typography variant="body1" color="textSecondary">
                After scanning the barcode image, the app will display a
                six-digit code you can enter below.
            </Typography>
            <Fields.Text
                onChange={value => onChange({ code: value })}
                className={classes.text}
                placeholder="123456"
                value={values.code}
                error={error && 'Invalid code, please try again'}
            />
        </>
    );
};

const FakeField = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.fakeField}>{children}</div>;
};
